import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { AppointmentEvent } from '../../types';

export const selectMissingSearchEmployeeIds = createSelector(
  [
    (state: RootState) => state.appointments,
  ],
  (appointmentsState) => {
    if (!appointmentsState.search.data) {
      return [];
    }
    const employeeIds: string[] = [];
    for (let itemIndex = 0; itemIndex < appointmentsState.search.data.length; itemIndex += 1) {
      const appointment = appointmentsState.search.data[itemIndex];
      const suggestedEmployeeId = (appointment.eventTypeData as AppointmentEvent)?.suggestedEmployee;
      if (suggestedEmployeeId && !appointment.employee) {
        employeeIds.push(suggestedEmployeeId);
      }
    }
    return employeeIds;
  },
);
